import { render, staticRenderFns } from "./Aggregator.vue?vue&type=template&id=33812534&scoped=true&"
import script from "./Aggregator.vue?vue&type=script&lang=js&"
export * from "./Aggregator.vue?vue&type=script&lang=js&"
import style0 from "./Aggregator.vue?vue&type=style&index=0&id=33812534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33812534",
  null
  
)

export default component.exports